import { render, staticRenderFns } from "./TextWithImageMiddle.vue?vue&type=template&id=b6b0c85c"
import script from "./TextWithImageMiddle.vue?vue&type=script&lang=js"
export * from "./TextWithImageMiddle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports